var exports = {
  "zr": "ScreenSharePickerModal.module__root___YmZzNk",
  "XV": "ScreenSharePickerModal.module__topBar___YmZzNk",
  "vR": "ScreenSharePickerModal.module__tabs___YmZzNk",
  "Gn": "ScreenSharePickerModal.module__tabLabel___YmZzNk",
  "Ll": "ScreenSharePickerModal.module__tabIcon___YmZzNk",
  "Qs": "ScreenSharePickerModal.module__content___YmZzNk",
  "Vg": "ScreenSharePickerModal.module__grid___YmZzNk",
  "Nr": "ScreenSharePickerModal.module__card___YmZzNk",
  "e5": "ScreenSharePickerModal.module__cardPending___YmZzNk",
  "VH": "ScreenSharePickerModal.module__preview___YmZzNk",
  "np": "ScreenSharePickerModal.module__previewDevice___YmZzNk",
  "Gh": "ScreenSharePickerModal.module__cardSelected___YmZzNk",
  "oz": "ScreenSharePickerModal.module__previewImage___YmZzNk",
  "yQ": "ScreenSharePickerModal.module__devicePreviewVideo___YmZzNk",
  "A3": "ScreenSharePickerModal.module__previewPlaceholder___YmZzNk",
  "Cd": "ScreenSharePickerModal.module__devicePreviewPlaceholder___YmZzNk",
  "mP": "ScreenSharePickerModal.module__previewIcon___YmZzNk",
  "rP": "ScreenSharePickerModal.module__previewOverlay___YmZzNk",
  "H5": "ScreenSharePickerModal.module__previewAction___YmZzNk",
  "zI": "ScreenSharePickerModal.module__cardBody___YmZzNk",
  "Dm": "ScreenSharePickerModal.module__cardSourceIcon___YmZzNk",
  "gL": "ScreenSharePickerModal.module__cardSourceIconImage___YmZzNk",
  "JJ": "ScreenSharePickerModal.module__cardTitle___YmZzNk",
  "wk": "ScreenSharePickerModal.module__state___YmZzNk",
  "Ml": "ScreenSharePickerModal.module__loadingState___YmZzNk",
  "hZ": "ScreenSharePickerModal.module__stateIcon___YmZzNk",
  "CY": "ScreenSharePickerModal.module__stateHeading___YmZzNk",
  "_A": "ScreenSharePickerModal.module__stateTitle___YmZzNk",
  "tM": "ScreenSharePickerModal.module__stateActions___YmZzNk",
  "xj": "ScreenSharePickerModal.module__osNotice___YmZzNk",
  "Hr": "ScreenSharePickerModal.module__downloadCta___YmZzNk",
  "wN": "ScreenSharePickerModal.module__downloadCopy___YmZzNk",
  "z5": "ScreenSharePickerModal.module__downloadTitle___YmZzNk",
  "h": "ScreenSharePickerModal.module__downloadDescription___YmZzNk",
  "qm": "ScreenSharePickerModal.module__downloadActions___YmZzNk",
  "aQ": "ScreenSharePickerModal.module__platformIcons___YmZzNk",
  "tV": "ScreenSharePickerModal.module__platformIcon___YmZzNk",
  "qr": "ScreenSharePickerModal.module__footer___YmZzNk",
  "wu": "ScreenSharePickerModal.module__footerStart___YmZzNk",
  "vM": "ScreenSharePickerModal.module__streamSummary___YmZzNk",
  "ru": "ScreenSharePickerModal.module__streamSummaryTitle___YmZzNk",
  "$o": "ScreenSharePickerModal.module__streamSummaryDetails___YmZzNk",
  "sw": "ScreenSharePickerModal.module__streamSummaryDetail___YmZzNk",
  "Xd": "ScreenSharePickerModal.module__streamButton___YmZzNk",
  "ZF": "ScreenSharePickerModal.module__previewNotice___YmZzNk",
  "cP": "ScreenSharePickerModal.module__previewNoticeText___YmZzNk",
  "vw": "ScreenSharePickerModal.module__previewNoticeInfoButton___YmZzNk",
  "Ip": "ScreenSharePickerModal.module__previewInfoContent___YmZzNk",
  "Jh": "ScreenSharePickerModal.module__previewInfoParagraph___YmZzNk",
  "NZ": "ScreenSharePickerModal.module__previewInfoSwitch___YmZzNk",
};

module.exports = exports;
